<template>
  <div class="report-page relative body-text">
    <div
      v-if="loading"
      class="absolute h-screen w-screen inset-0 flex justify-center align-center"
    >
      <div class="m-auto" v-loading="true"></div>
    </div>
    <template v-else>
      <div class="fixed right-0 bottom-0 pb-10 pr-5 print:hidden z-50">
        <el-button
          onclick="window.print()"
          type="primary"
          size="medium"
          class="transform scale-150"
          >打印</el-button
        >
      </div>
      <div class="relative mx-12" v-if="info.reportNum">
        <div
          v-if="mode !== 'body'"
          class="page-container h-screen print:h-screen"
        >
          <report-cover class="page-body" :info="info" />
        </div>
        <div
          v-if="mode !== 'body'"
          class="page-container h-screen print:h-screen"
        >
          <report-declare class="page-body" :info="info" />
        </div>
        <div v-if="mode === 'cover'" class="page-container print:show"></div>
        <div v-if="mode !== 'cover'" class="page-container print:show">
          <report-category class="page-body" :info="info" />
        </div>
        <div v-if="mode === 'body'" class="page-container print:show"></div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            title="吉林市国家级中小企业数字化转型试点城市——中小企业数字化水平评测报告"
          />
          <report-dash class="page-body" :info="info" />
          <report-page-foot
            class="page-footer"
            :info="info"
            :page="1"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            :title="`试点企业：${info.eName}`"
          />
          <report-dimension class="page-body" :info="info" :show-dash="true" />
          <report-page-foot-title
            class="page-footer"
            :info="info"
            :page="2"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            title="吉林市国家级中小企业数字化转型试点城市——中小企业数字化水平评测报告"
          />
          <report-dimension-chart class="page-body" :info="info" />
          <report-page-foot
            class="page-footer"
            :info="info"
            :page="3"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            :title="`试点企业：${info.eName}`"
          />
          <report-digit-a1 class="page-body" :info="info" />
          <report-page-foot-title
            class="page-footer"
            :info="info"
            :page="4"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            title="吉林市国家级中小企业数字化转型试点城市——中小企业数字化水平评测报告"
          />
          <report-digit-a2 class="page-body" :info="info" />
          <report-page-foot
            class="page-footer"
            :info="info"
            :page="5"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            :title="`试点企业：${info.eName}`"
          />
          <report-digit-b1 class="page-body" :info="info" />
          <report-page-foot-title
            class="page-footer"
            :info="info"
            :page="6"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            title="吉林市国家级中小企业数字化转型试点城市——中小企业数字化水平评测报告"
          />
          <report-digit-b2 class="page-body" :info="info" />
          <report-page-foot
            class="page-footer"
            :info="info"
            :page="7"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            :title="`试点企业：${info.eName}`"
          />
          <report-digit-c1 class="page-body" :info="info" />
          <report-page-foot-title
            class="page-footer"
            :info="info"
            :page="8"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            title="吉林市国家级中小企业数字化转型试点城市——中小企业数字化水平评测报告"
          />
          <report-digit-c2 class="page-body" :info="info" />
          <report-page-foot
            class="page-footer"
            :info="info"
            :page="9"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            :title="`试点企业：${info.eName}`"
          />
          <report-digit class="page-body" :info="info" :show-dash="true" />
          <report-page-foot-title
            class="page-footer"
            :info="info"
            :page="10"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            title="吉林市国家级中小企业数字化转型试点城市——中小企业数字化水平评测报告"
          />
          <report-digit2 class="page-body" :info="info" />
          <report-page-foot
            class="page-footer"
            :info="info"
            :page="11"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            :title="`试点企业：${info.eName}`"
          />
          <report-digit-d class="page-body" :info="info" />
          <report-page-foot-title
            class="page-footer"
            :info="info"
            :page="12"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            title="吉林市国家级中小企业数字化转型试点城市——中小企业数字化水平评测报告"
          />
          <report-digit-e1 class="page-body" :info="info" />
          <report-page-foot
            class="page-footer"
            :info="info"
            :page="13"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            :title="`试点企业：${info.eName}`"
          />
          <report-digit-e2 class="page-body" :info="info" />
          <report-page-foot-title
            class="page-footer"
            :info="info"
            :page="14"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            title="吉林市国家级中小企业数字化转型试点城市——中小企业数字化水平评测报告"
          />
          <report-digit-f class="page-body" :info="info" />
          <report-page-foot
            class="page-footer"
            :info="info"
            :page="15"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            :title="`试点企业：${info.eName}`"
          />
          <report-digit-g class="page-body" :info="info" />
          <report-page-foot-title
            class="page-footer"
            :info="info"
            :page="16"
            :total="pig"
          />
        </div>
        <div v-if="mode !== 'cover'" class="page-container">
          <report-page-head
            class="page-header"
            title="吉林市国家级中小企业数字化转型试点城市——中小企业数字化水平评测报告"
          />
          <report-sign class="page-body" :info="info" />
          <report-page-foot-page class="page-footer" :page="17" :total="pig" />
        </div>
        <div v-if="mode !== 'body'" class="page-container">
          <report-cover-back class="page-body" :info="info" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import "@/assets/app.css";
import ReportCover from "@/components/report/cover";
import ReportCategory from "@/components/report/category";
import ReportDeclare from "@/components/report/declare";
import ReportPageHead from "@/components/report/page-head";
import ReportPageFoot from "@/components/report/page-foot";
import ReportPageFootTitle from "@/components/report/page-foot-title";
import ReportPageFootPage from "@/components/report/page-foot-page";
import ReportDash from "@/components/report/dash";
import ReportDimension from "@/components/report/dimension";
import ReportDimensionChart from "@/components/report/dimension-chart";
import ReportDigit from "@/components/report/digit";
import ReportDigitA1 from "@/components/report/digit-a1";
import ReportDigitA2 from "@/components/report/digit-a2";
import ReportDigitB1 from "@/components/report/digit-b1";
import ReportDigitB2 from "@/components/report/digit-b2";
import ReportDigitC1 from "@/components/report/digit-c1";
import ReportDigitC2 from "@/components/report/digit-c2";
import ReportDigit2 from "@/components/report/digit2";
import ReportDigitD from "@/components/report/digit-d";
import ReportDigitE1 from "@/components/report/digit-e1";
import ReportDigitE2 from "@/components/report/digit-e2";
import ReportDigitF from "@/components/report/digit-f";
import ReportDigitG from "@/components/report/digit-g";
import ReportSign from "@/components/report/sign";
import * as XLSX from "xlsx";
import { getFile, makeExportExcel } from "@/api/enterprise";
import ReportCoverBack from "@/components/report/cover-back.vue";
export default {
  components: {
    ReportCoverBack,
    ReportCover,
    ReportCategory,
    ReportDeclare,
    ReportPageHead,
    ReportPageFoot,
    ReportPageFootTitle,
    ReportPageFootPage,
    ReportDash,
    ReportDimension,
    ReportDimensionChart,
    ReportDigit,
    ReportDigitA1,
    ReportDigitA2,
    ReportDigitB1,
    ReportDigitB2,
    ReportDigitC1,
    ReportDigitC2,
    ReportDigit2,
    ReportDigitD,
    ReportDigitE1,
    ReportDigitE2,
    ReportDigitF,
    ReportDigitG,
    ReportSign,
  },
  data() {
    return {
      loading: false,
      pig: 17,
      mode: "",
      info: {},
    };
  },
  created() {
    if (!window.opener) {
      window.close();
    }
  },
  mounted() {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/buckets/fonts/font.css";
    document.head.appendChild(link);

    this.mode = this.$route.query.mode || "";

    window.addEventListener("message", this.handleMessage);
    window.opener.postMessage("getReportInfo");
  },
  destroyed() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage({ data }) {
      try {
        this.info = JSON.parse(data);
        console.log(this.info);

        const str = this.info.reportNum.replace("（", "").replace("）", "");
        const year = str.substring(str.length - 4, str.length);
        const name = `${this.info.levelsName}${this.info.d.userId}（${year}）${this.info.eName}`;
        if (this.mode === "cover") {
          document.title = `${name}报告封皮`;
        } else if (this.mode === "body") {
          document.title = `${name}报告正文`;
        } else {
          document.title = `${name}`;
        }

        this.loading = false;
        window.removeEventListener("message", this.handleMessage);
      } catch (e) {
        console.log("error", e);
      }
    },
    async handleExportExcel() {
      const excel = await makeExportExcel([this.info.d.userId]);
      if (excel.code !== 200) {
        return Promise.reject(new Error("导出失败"));
      }
      await getFile(excel.message)
        .then((res) => res.data)
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${this.info.i.enterpriseName}-数字化水平评测表.xlsx`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        });
    },
    handleExportDevice() {
      const list = this.info.answerArr[1]?.otherAns?.list ?? [];
      const arr = [
        ["车间名称", "plant"],
        ["产线名称", "line"],
        ["设备编号", "code"],
        ["设备名称", "name"],
        ["设备分类", "type"],
        ["规格/型号", "size"],
        ["品牌/厂商", "factory"],
        ["入场日期", "date"],
        ["设备状态", "status"],
        ["是否已联网", "online"],
        ["是否已数控化", "digit"],
        ["是否已实时采集数据", "real"],
        ["保养周期（日）", "during"],
        ["上次保养的日期", "last"],
      ];
      const ws = XLSX.utils.json_to_sheet(
        list.map((v) =>
          arr.reduce((o, a) => Object.assign(o, { [a[0]]: v[a[1]] }), {})
        )
      );
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, `${this.info.i.enterpriseName}-设备清单.xlsx`);
    },
  },
};
</script>
